export default {
    additionalInformation: '追加情報',
    editTeamMemberInfo: 'メンバー情報を編集',
    keyValues: {
        createdBy: '作成者',
        dateCreated: '作成日',
        endDate: '終了日',
        license: '一般権限',
        senderSignature: '差出人署名',
        startDate: '加入日',
    },
    resendInvitation: '招待状の再送信',
    revoke: 'メンバーの退会',
};
